import { request } from "../../apis";

export const apiGetSessionSchedule = (params: any): any =>
  request("get", `/api/session/schedule/list`, params, true);
